// Modules
import React from 'react';
import moment from 'moment';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { isUndefined } from 'lodash';
import i18n from 'i18n-react';

// Styling
import './inputfield.scss';

const dateFormat = 'DD-MM-YYYY [om] HH:mm:ss';

const InputField = (props) => {
    const { label, value, onChange, noDefaultFormatting, type, inputAddonBefore, inputAddonAfter, checked, name, placeholder } = props;
    const { disabled, min, max, minLength, maxLength, required, className, inputGroupAlreadyExist, defaultValue } = props;
    const { readOnly, onFocus } = props;

    // Format the value to a ? if it's empty
    let inputValue = value;
    if (!value && !onChange && !noDefaultFormatting) {
        inputValue = '?';
    }
    if (type === 'date' && inputValue !== '?') {
        // Format the value if it's not empty
        inputValue = moment(value).format(dateFormat);
        if (inputValue === 'Invalid date') {
            inputValue = '?';
        }
    }

    // Check if input is Controlled:
    const controlledProps = isUndefined(value) ? { defaultValue } : { value: inputValue || '' };

    // Different HTML structure if the text is formatted (either text is formatted or it has a statusLabel)
    if (type.includes('formattedText')) {
        return (
            <div className="form-group">
                {!!label && <label>{i18n.translate(label)}</label>}
                <div
                    placeholder={props.placeholder}
                    className={cx({
                        'input no-hover': !!disabled,
                        'no-max-width': !!className && className.includes('no-max-width'),
                    })}>
                    {inputValue}
                </div>
            </div>
        );
    }

    const checkTypes = type === 'checkbox' ? { checked } : {};

    // Set-up the input
    const input = (
        <input
            // value={inputValue || ''}
            type={type === 'date' ? 'text' : type}
            name={name}
            placeholder={placeholder}
            className={disabled ? 'no-hover' : ''}
            min={min}
            max={max}
            disabled={!!disabled}
            readOnly={!!readOnly}
            minLength={minLength}
            maxLength={maxLength}
            required={!!required}
            autoComplete={type === 'password' ? 'new-password' : 'off'}
            onChange={onChange}
            onFocus={onFocus}
            {...checkTypes}
            {...controlledProps}
        />
    );

    // No <form-group> and <input-group> if there is no label provided
    if (!label && !inputGroupAlreadyExist) return <div className="input-group">{input}</div>;
    if (inputGroupAlreadyExist) return <React.Fragment>{input}</React.Fragment>;

    return (
        <div className="form-group">
            {!!label && <label>{i18n.translate(label)}</label>}
            <div className="input-group">
                {!!inputAddonBefore && <div className="input-group-addon">{inputAddonBefore}</div>}
                {input}
                {!!inputAddonAfter && <div className="input-group-addon">{inputAddonAfter}</div>}
            </div>
        </div>
    );
};

InputField.defaultProps = {
    onFocus: () => {},
};

InputField.propTypes = {
    label: PropTypes.string,
    type: PropTypes.string,
    name: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object]),
    placeholder: PropTypes.string,
    disabled: PropTypes.bool,
    onChange: PropTypes.func,
    onFocus: PropTypes.func,
};

export default InputField;
